<template>
    <ModalComponent
        :name="'borrar-' + codigo.id"
        :title="'¿Seguro que quieres borrar el código: ' + codigo.codigo + '?'"
        @close="() => close(false)"
    >
        <b-row class="text-center">
            <b-col cols="12" class="mb-3">
                <h1 class="font-weight-bold mb-0">¿BORRAR CÓDIGO?</h1>
                <small>*Si el código ha sido usado no se podrá borrar</small>
            </b-col>
            <b-col cols="12">
                <Button type="button" name="button" @click="borrarCodigo" :disabled="loading">SI, BORRAR</Button>
            </b-col>
        </b-row>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: {
            codigo: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: false
            }
        },
        methods: {
            borrarCodigo() {
                this.loading = true;

                var params = {
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    codigo: this.codigo.id,
                    filters : {}
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.codigos-qr.eliminar'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.$emit('terminado');
                    this.close(true);
                }).catch(error => {
                    this.$toast.error(error.response?.data?.message);
                    this.close(false);
                }).finally(() => this.loading = false);
            },
            close(borrado) {
                this.$emit('close', 'borrar-' + this.codigo.id, borrado);
            }
        },
        computed: {
            evento_id() {
                return parseInt(this.$route.params.evento_id);
            },
            sesion_id() {
                return parseInt(this.$route.params.sesion_id);
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
